import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
} from "@themesberg/react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
  postLoginWithMobile,
  sendOptForLogin,
  sendOtp,
} from "../../Service/AllLoginAPI";

import BgImage from "../../assets/img/illustrations/signwithmobile.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Routes } from "../../routes";
import { faMobileAlt } from "@fortawesome/free-solid-svg-icons";
import swal from "sweetalert";

export default () => {
  const [isoCode, setIsoCode] = useState("");
  const [mobilNno, setMobileNo] = useState("");
  const history = useHistory();

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const loginStatus = sessionStorage.getItem("loginStatus");
    const hasToken = !!token && token !== "null" && token !== "undefined" && token !== "";
    const isLoggedStatus = loginStatus === "true" || loginStatus === true;
    if (hasToken || isLoggedStatus) {
      history.replace("/");
    }
  }, [history]);
  const submitLoginWithMobile = async (e) => {
    try {
      e.preventDefault();
      if (mobilNno !== "") {
        const data = {
          mobileNo: `${mobilNno}`,
        };
        console.log("SignMobile :-", data);
        await sendOtp(data)
          .then((result) => {
            console.log("Login Result", result);
            if (result.data.response === "number found") {
              swal("Great", "OTP send on registered number", "success");
              history.push("/sign-otp");
            } else {
              swal("Failed", "Number not matched", "warning");
            }
          })
          .catch((error) => {
            console.log("Login Error", error);
            swal("Login Failed", "Failed to send OTP", "error");
          });
      } else if (mobilNno === "") {
        swal("Failed", "Please enter mobile no", "error");
      }
    } catch (error) {
      console.log(error);
      swal(
        "Failed",
        "Something went wrong please check your internet",
        "error"
      );
    }
  };

  return (
    <main className="bg-dark vh-100">
      <section className="d-flex align-items-center my-5 mt-lg-9 mb-lg-5">
        <Container>
          <Row
            className="justify-content-center form-bg-image"
            style={{ backgroundImage: `url(${BgImage})` }}
          >
            <Col
              xs={12}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="mb-4 mb-lg-0 bg-white shadow-soft border rounded border-light p-4 p-lg-5 w-100 fmxw-500">
                <div className="text-center text-md-center mb-4 mt-md-0">
                  <h3 className="signinHead mb-0">Sign In With Mobile</h3>
                </div>
                <Form className="mt-4">
                  <Form.Group id="mobile" className="mb-4">
                    <Form.Label>Your Mobile No.</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <FontAwesomeIcon icon={faMobileAlt} />
                      </InputGroup.Text>
                      {/* <Form.Control
                        autoFocus
                        required
                        type="text"
                        placeholder="+91"
                        style={{
                          borderRight: "0.0625rem solid #d1d7e0",
                          paddingLeft: "6px",
                        }}
                        onChange={(e) => setIsoCode(e.target.value)}
                      /> */}
                      {/* <Form.Control
                        required
                        type="text"
                        placeholder="Mobile No."
                        style={{
                          width: "68%",
                          borderLeft: "0.0625rem solid #d1d7e0",
                          paddingLeft: "6px",
                        }}
                        onChange={(e) => setMobileNo(e.target.value)}
                      /> */}

                      <Form.Control
                        required
                        type="tel" // Use type "tel" for phone numbers
                        placeholder="Enter Mobile No."
                        style={{
                          width: "68%",
                          borderLeft: "0.0625rem solid #d1d7e0",
                          paddingLeft: "6px",
                        }}
                        onChange={(e) => {
                          const inputValue = e.target.value.replace(/\D/g, "");
                          if (inputValue.length > 10) {
                            e.target.value = inputValue.slice(0, 10);
                          } else {
                            e.target.value = inputValue;
                          }
                          setMobileNo(e.target.value);
                        }}
                      />
                    </InputGroup>
                  </Form.Group>
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                    onClick={submitLoginWithMobile}
                  >
                    Send OTP
                  </Button>
                </Form>
                <div className="mt-3 mb-4 text-center">
                  <span className="fw-normal">
                    or login with{" "}
                    <Card.Link
                      className="small text-end"
                      as={Link}
                      to={Routes.Signin.path}
                    >
                      Username
                    </Card.Link>
                  </span>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
